import React, { useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Footer.css';
import { MyContext } from './Context';

function Footer() {
  const { isSidebarOpen } = useContext(MyContext);
  const sidebarWidth = isSidebarOpen ? 42 : 300;

  return (
    <div className="footer-wrapper" style={{ left: sidebarWidth }}>
      <footer className="app-footer">
        <div className="footer-brand">
          <span className="footer-mark" aria-hidden="true" />
          <span className="footer-text">Kravez</span>
          <span className="footer-version">v1.0</span>
        </div>
        <div className="footer-text footer-copy">© {new Date().getFullYear()} All Rights Reserved</div>
      </footer>
    </div>
  );
}

export default Footer;